import { render, staticRenderFns } from "./ResourceCreateDetails.vue?vue&type=template&id=6cb2780b&"
import script from "./ResourceCreateDetails.vue?vue&type=script&lang=js&"
export * from "./ResourceCreateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb2780b')) {
      api.createRecord('6cb2780b', component.options)
    } else {
      api.reload('6cb2780b', component.options)
    }
    module.hot.accept("./ResourceCreateDetails.vue?vue&type=template&id=6cb2780b&", function () {
      api.rerender('6cb2780b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/resources/steps/ResourceCreateDetails.vue"
export default component.exports